import { render, staticRenderFns } from "./TableArea.vue?vue&type=template&id=b609fd92&scoped=true"
import script from "./TableArea.vue?vue&type=script&lang=js"
export * from "./TableArea.vue?vue&type=script&lang=js"
import style0 from "./TableArea.vue?vue&type=style&index=0&id=b609fd92&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b609fd92",
  null
  
)

export default component.exports